import axios from '@/axios.js'

export default {
    getInteractiveMaps: async (extraParams, page) => {
        const response = await axios.adminapi.get(`v4/interactive-maps`,{
            params: {
                ...extraParams,
                ...(page ? { page: page } : {})
            }
        })
        return response.data.object
    },

    getInteractiveMap: async (uuid) => {
        const response = await axios.adminapi.get(`v4/interactive-maps/${uuid}`)
        return response.data.object
    },

    createInteractiveMap: async (uuid, data) => {
        const response = await axios.adminapi.post(`v4/interactive-maps/${uuid}`, data)
        return response.data.object
    },

    updateInteractiveMap: async (uuid, data) => {
        const response = await axios.adminapi.patch(`v4/interactive-maps/${uuid}`, data)
        return response.data.object
    },

    deleteInteractiveMap: async (uuid) => {
        const response = await axios.adminapi.delete(`v4/interactive-maps/${uuid}`)
        return response.data.object
    },
}
